// Longevity Dashboard Service - API calls for Longevity Module
import api from './api';

const BASE_URL = '/api/v1/longevity';

// Profile
export const getLongevityProfile = async (patientId) => {
  const response = await api.get(`${BASE_URL}/profile/${patientId}`);
  return response.data;
};

export const updateLongevityProfile = async (patientId, profileData) => {
  const response = await api.put(`${BASE_URL}/profile/${patientId}`, profileData);
  return response.data;
};

// Biomarkers
export const getBiomarkers = async (patientId) => {
  const response = await api.get(`${BASE_URL}/biomarkers/${patientId}`);
  return response.data;
};

export const getBiomarkerHistory = async (patientId, years = 5) => {
  const response = await api.get(`${BASE_URL}/biomarkers/${patientId}/history?years=${years}`);
  return response.data;
};

// System Scores
export const getSystemScores = async (patientId) => {
  const response = await api.get(`${BASE_URL}/scores/${patientId}`);
  return response.data;
};

export const getLongevitySummary = async (patientId) => {
  const response = await api.get(`${BASE_URL}/scores/${patientId}/summary`);
  return response.data;
};

// Lifestyle
export const getLifestyleData = async (patientId) => {
  const response = await api.get(`${BASE_URL}/lifestyle/${patientId}`);
  return response.data;
};

// Insights & Alerts
export const getInsights = async (patientId) => {
  const response = await api.get(`${BASE_URL}/insights/${patientId}`);
  return response.data;
};

export const getDriftAlerts = async (patientId) => {
  const response = await api.get(`${BASE_URL}/alerts/${patientId}`);
  return response.data;
};

// Preventive Care
export const getPreventiveCare = async (patientId) => {
  const response = await api.get(`${BASE_URL}/preventive-care/${patientId}`);
  return response.data;
};

// Recommendations
export const getRecommendations = async (patientId) => {
  const response = await api.get(`${BASE_URL}/recommendations/${patientId}`);
  return response.data;
};

export default {
  getLongevityProfile,
  updateLongevityProfile,
  getBiomarkers,
  getBiomarkerHistory,
  getSystemScores,
  getLongevitySummary,
  getLifestyleData,
  getInsights,
  getDriftAlerts,
  getPreventiveCare,
  getRecommendations
};
